/** Seed catalog — USD unitPrice kept; UI converts via selected currency (default NGN). Offline fallback when Supabase unset. */
import {
  USD_TO_NGN,
  formatMoney,
  formatMoneyNgn,
} from '../lib/currency.js';

export { USD_TO_NGN, formatMoney, formatMoneyNgn };

export const CATEGORIES = [
  'All',
  'Industrial Parts',
  'Packaging',
  'Textiles',
  'Electronics',
];

export const PRODUCTS = [
  {
    id: 'ip-bearing-6205',
    name: 'Deep Groove Ball Bearing 6205-2RS',
    sku: 'IP-6205-2RS',
    factory: 'Nordic Precision AB',
    category: 'Industrial Parts',
    description:
      'Sealed chrome-steel deep groove bearings for conveyor and motor applications. ISO 15 dimensional compliance, C3 clearance.',
    specs: {
      Material: 'GCr15 chrome steel',
      Seal: '2RS rubber',
      Bore: '25 mm',
      'OD / Width': '52 / 15 mm',
      Clearance: 'C3',
    },
    moq: 500,
    unit: 'pcs',
    unitPrice: 1.85,
    priceTiers: [
      { minQty: 500, price: 1.85 },
      { minQty: 2000, price: 1.62 },
      { minQty: 10000, price: 1.41 },
    ],
    leadTimeDays: 21,
    icon: '⚙️',
    featured: true,
  },
  {
    id: 'ip-hex-bolt-m10',
    name: 'Hex Bolt M10×50 Class 8.8 (Zinc)',
    sku: 'IP-HEX-M10-50',
    factory: 'Ohio Tool Foundry',
    category: 'Industrial Parts',
    description:
      'Metric hex bolts, partial thread, zinc-plated. Supplied in bulk cartons with mill certs on request.',
    specs: {
      Standard: 'ISO 4014',
      Grade: '8.8',
      Finish: 'Zinc clear',
      Thread: 'M10 × 1.5',
      Length: '50 mm',
    },
    moq: 2000,
    unit: 'pcs',
    unitPrice: 0.12,
    priceTiers: [
      { minQty: 2000, price: 0.12 },
      { minQty: 10000, price: 0.095 },
      { minQty: 50000, price: 0.078 },
    ],
    leadTimeDays: 14,
    icon: '🔩',
    featured: false,
  },
  {
    id: 'ip-pneumatic-cyl',
    name: 'ISO 15552 Pneumatic Cylinder Ø63',
    sku: 'IP-PN-63-100',
    factory: 'Nordic Precision AB',
    category: 'Industrial Parts',
    description:
      'Double-acting pneumatic cylinder, 100 mm stroke, magnetic piston, adjustable cushions.',
    specs: {
      Bore: '63 mm',
      Stroke: '100 mm',
      Port: 'G1/4',
      Pressure: '1–10 bar',
      Mount: 'ISO 15552',
    },
    moq: 50,
    unit: 'pcs',
    unitPrice: 48.5,
    priceTiers: [
      { minQty: 50, price: 48.5 },
      { minQty: 200, price: 42.0 },
      { minQty: 500, price: 37.5 },
    ],
    leadTimeDays: 28,
    icon: '🛢️',
    featured: true,
  },
  {
    id: 'pk-mailer-poly',
    name: 'Poly Mailer Bags 10×13 (Opaque)',
    sku: 'PK-MAIL-1013',
    factory: 'Pearl River Packaging',
    category: 'Packaging',
    description:
      'Self-seal poly mailers with tear strip. Opaque white, water-resistant. Ideal for apparel and soft goods fulfillment.',
    specs: {
      Size: '10 × 13 in',
      Material: 'LDPE co-ex',
      Thickness: '2.5 mil',
      Closure: 'Self-seal + tear',
      Print: 'Blank',
    },
    moq: 5000,
    unit: 'pcs',
    unitPrice: 0.085,
    priceTiers: [
      { minQty: 5000, price: 0.085 },
      { minQty: 25000, price: 0.068 },
      { minQty: 100000, price: 0.052 },
    ],
    leadTimeDays: 12,
    icon: '📦',
    featured: true,
  },
  {
    id: 'pk-corrugated-rsc',
    name: 'Corrugated RSC Carton 18×14×12',
    sku: 'PK-RSC-181412',
    factory: 'Anatolia Corrugated',
    category: 'Packaging',
    description:
      'Single-wall C-flute RSC cartons, kraft outer. ECT-32. Flat-shipped, scored and slotted.',
    specs: {
      ID: '18 × 14 × 12 in',
      Board: 'C-flute kraft',
      ECT: '32',
      Joint: 'Glued',
      Bundle: '20 flats',
    },
    moq: 1000,
    unit: 'pcs',
    unitPrice: 0.92,
    priceTiers: [
      { minQty: 1000, price: 0.92 },
      { minQty: 5000, price: 0.78 },
      { minQty: 20000, price: 0.65 },
    ],
    leadTimeDays: 18,
    icon: '📫',
    featured: false,
  },
  {
    id: 'pk-stretch-film',
    name: 'Machine Stretch Film 20″ 80ga',
    sku: 'PK-STR-2080',
    factory: 'Pearl River Packaging',
    category: 'Packaging',
    description:
      'Cast LLDPE machine-grade stretch film for pallet wrapping. High cling, consistent gauge.',
    specs: {
      Width: '20 in',
      Gauge: '80',
      Length: '5000 ft / roll',
      Core: '3 in',
      Type: 'Cast LLDPE',
    },
    moq: 48,
    unit: 'rolls',
    unitPrice: 28.0,
    priceTiers: [
      { minQty: 48, price: 28.0 },
      { minQty: 192, price: 24.5 },
      { minQty: 480, price: 21.0 },
    ],
    leadTimeDays: 10,
    icon: '🎞️',
    featured: false,
  },
  {
    id: 'tx-jersey-180',
    name: 'Cotton Jersey Knit 180 gsm (Greige)',
    sku: 'TX-JER-180',
    factory: 'Gujarat Weave Mills',
    category: 'Textiles',
    description:
      'Single jersey knit, 100% cotton, greige ready for dye. Suitable for tees and loungewear blanks.',
    specs: {
      Content: '100% cotton',
      Weight: '180 gsm',
      Width: '180 cm open',
      Construction: 'Single jersey',
      Finish: 'Greige',
    },
    moq: 2000,
    unit: 'meters',
    unitPrice: 2.45,
    priceTiers: [
      { minQty: 2000, price: 2.45 },
      { minQty: 10000, price: 2.15 },
      { minQty: 50000, price: 1.92 },
    ],
    leadTimeDays: 25,
    icon: '🧵',
    featured: true,
  },
  {
    id: 'tx-twill-chino',
    name: 'Cotton Twill Chino 240 gsm',
    sku: 'TX-TWL-240',
    factory: 'Lisbon Knit Collective',
    category: 'Textiles',
    description:
      'Piece-dyed cotton twill for chinos and workwear. Soft hand, mercerized option available.',
    specs: {
      Content: '98% cotton / 2% elastane',
      Weight: '240 gsm',
      Width: '150 cm',
      Weave: '3/1 twill',
      Color: 'Navy (stock)',
    },
    moq: 1500,
    unit: 'meters',
    unitPrice: 4.8,
    priceTiers: [
      { minQty: 1500, price: 4.8 },
      { minQty: 5000, price: 4.35 },
      { minQty: 15000, price: 3.95 },
    ],
    leadTimeDays: 30,
    icon: '👔',
    featured: false,
  },
  {
    id: 'tx-woven-label',
    name: 'Damask Woven Labels (Custom)',
    sku: 'TX-LBL-DMK',
    factory: 'Lisbon Knit Collective',
    category: 'Textiles',
    description:
      'High-density damask woven care/brand labels. Artwork setup included above MOQ; fold & cut options.',
    specs: {
      Size: '50 × 20 mm (std)',
      Density: 'High damask',
      Fold: 'Center fold',
      Colors: 'Up to 8',
      Finish: 'Soft cut',
    },
    moq: 10000,
    unit: 'pcs',
    unitPrice: 0.045,
    priceTiers: [
      { minQty: 10000, price: 0.045 },
      { minQty: 50000, price: 0.032 },
      { minQty: 200000, price: 0.024 },
    ],
    leadTimeDays: 20,
    icon: '🏷️',
    featured: false,
  },
  {
    id: 'el-mlcc-0805',
    name: 'MLCC 0805 10µF 25V X5R',
    sku: 'EL-MLCC-0805-10U',
    factory: 'Taipei Passive Components',
    category: 'Electronics',
    description:
      'Multilayer ceramic capacitors on tape & reel. AEC-Q200 lot available on request.',
    specs: {
      Package: '0805',
      Capacitance: '10 µF',
      Voltage: '25 V',
      Dielectric: 'X5R',
      Packaging: 'Tape & reel',
    },
    moq: 10000,
    unit: 'pcs',
    unitPrice: 0.018,
    priceTiers: [
      { minQty: 10000, price: 0.018 },
      { minQty: 50000, price: 0.014 },
      { minQty: 250000, price: 0.011 },
    ],
    leadTimeDays: 16,
    icon: '🔌',
    featured: true,
  },
  {
    id: 'el-mcu-cortex',
    name: 'ARM Cortex-M0+ MCU 48MHz LQFP48',
    sku: 'EL-MCU-M0-48',
    factory: 'Shenzhen CircuitWorks',
    category: 'Electronics',
    description:
      'General-purpose 32-bit MCU with 64KB flash, 8KB SRAM, multiple UART/SPI/I2C. Tray packing.',
    specs: {
      Core: 'Cortex-M0+',
      Clock: '48 MHz',
      Flash: '64 KB',
      Package: 'LQFP-48',
      Temp: '-40 to +85 °C',
    },
    moq: 1000,
    unit: 'pcs',
    unitPrice: 0.95,
    priceTiers: [
      { minQty: 1000, price: 0.95 },
      { minQty: 5000, price: 0.82 },
      { minQty: 25000, price: 0.71 },
    ],
    leadTimeDays: 35,
    icon: '💻',
    featured: true,
  },
  {
    id: 'el-usb-c-conn',
    name: 'USB-C Receptacle 16-pin SMT',
    sku: 'EL-USBC-16',
    factory: 'Shenzhen CircuitWorks',
    category: 'Electronics',
    description:
      'Mid-mount USB Type-C receptacle, 16-pin for USB 2.0. Gold-plated contacts, tape & reel.',
    specs: {
      Pins: '16',
      Mount: 'SMT mid-mount',
      Spec: 'USB 2.0',
      Plating: 'Gold flash',
      Pack: 'Tape & reel',
    },
    moq: 5000,
    unit: 'pcs',
    unitPrice: 0.22,
    priceTiers: [
      { minQty: 5000, price: 0.22 },
      { minQty: 20000, price: 0.18 },
      { minQty: 100000, price: 0.145 },
    ],
    leadTimeDays: 22,
    icon: '🔋',
    featured: false,
  },
  {
    id: 'ip-gen-set-bracket',
    name: 'Generator Mounting Bracket Set (Steel)',
    sku: 'NG-IP-GEN-BRK',
    factory: 'Apapa Heavy Fabrication',
    category: 'Industrial Parts',
    description:
      'Welded steel mounting brackets for 10–50 kVA gensets. Hot-dip galvanized. Lagos-made for distributors stocking power equipment.',
    specs: {
      Material: 'Mild steel',
      Finish: 'Hot-dip galvanized',
      Fit: '10–50 kVA frames',
      Origin: 'Lagos, Nigeria',
      Pack: '4 brackets / set',
    },
    moq: 40,
    unit: 'sets',
    unitPrice: 28.5,
    unitPriceNgn: 45600,
    priceTiers: [
      { minQty: 40, price: 28.5 },
      { minQty: 120, price: 24.0 },
      { minQty: 400, price: 21.5 },
    ],
    priceTiersNgn: [
      { minQty: 40, price: 45600 },
      { minQty: 120, price: 38400 },
      { minQty: 400, price: 34400 },
    ],
    leadTimeDays: 14,
    icon: '🏗️',
    featured: true,
  },
  {
    id: 'pk-sachet-water-film',
    name: 'Pure Water Sachet Film (LDPE Roll)',
    sku: 'NG-PK-SW-LDPE',
    factory: 'Aba Polymer Packaging Ltd',
    category: 'Packaging',
    description:
      'Food-grade LDPE film rolls for sachet water sealing lines. Common widths for South-East fillers; bulk pricing for distributors.',
    specs: {
      Material: 'LDPE food-grade',
      Width: '280 mm (std)',
      Gauge: '45–50 µm',
      Origin: 'Aba, Nigeria',
      Core: '76 mm',
    },
    moq: 20,
    unit: 'rolls',
    unitPrice: 42.0,
    unitPriceNgn: 67200,
    priceTiers: [
      { minQty: 20, price: 42.0 },
      { minQty: 80, price: 36.5 },
      { minQty: 200, price: 32.0 },
    ],
    priceTiersNgn: [
      { minQty: 20, price: 67200 },
      { minQty: 80, price: 58400 },
      { minQty: 200, price: 51200 },
    ],
    leadTimeDays: 10,
    icon: '💧',
    featured: true,
  },
  {
    id: 'tx-ankara-wax-print',
    name: 'Ankara Wax Print Fabric (6-yard)',
    sku: 'NG-TX-ANK-6Y',
    factory: 'Kano Textile Mills',
    category: 'Textiles',
    description:
      'Cotton wax-print (Ankara) in mixed wholesale designs. Sold in 6-yard pieces for fashion wholesalers across Nigeria and ECOWAS.',
    specs: {
      Content: '100% cotton',
      Length: '6 yards / piece',
      Width: '120 cm',
      Origin: 'Kano, Nigeria',
      Finish: 'Wax print',
    },
    moq: 200,
    unit: 'pieces',
    unitPrice: 6.5,
    unitPriceNgn: 10400,
    priceTiers: [
      { minQty: 200, price: 6.5 },
      { minQty: 1000, price: 5.6 },
      { minQty: 5000, price: 4.9 },
    ],
    priceTiersNgn: [
      { minQty: 200, price: 10400 },
      { minQty: 1000, price: 8960 },
      { minQty: 5000, price: 7840 },
    ],
    leadTimeDays: 12,
    icon: '🦚',
    featured: true,
  },
  {
    id: 'el-inverter-battery-rack',
    name: 'Inverter Battery Rack (4-slot)',
    sku: 'NG-EL-INV-RACK',
    factory: 'Ikeja Power Components',
    category: 'Electronics',
    description:
      'Powder-coated steel racks for tubular / gel batteries used with home and SME inverters. Popular with Lagos electrical distributors.',
    specs: {
      Slots: '4 battery',
      Finish: 'Powder coat',
      Load: 'Up to 200 Ah cells',
      Origin: 'Ikeja, Lagos',
      Pack: 'Knock-down flat',
    },
    moq: 25,
    unit: 'pcs',
    unitPrice: 55.0,
    unitPriceNgn: 88000,
    priceTiers: [
      { minQty: 25, price: 55.0 },
      { minQty: 100, price: 48.0 },
      { minQty: 300, price: 42.5 },
    ],
    priceTiersNgn: [
      { minQty: 25, price: 88000 },
      { minQty: 100, price: 76800 },
      { minQty: 300, price: 68000 },
    ],
    leadTimeDays: 18,
    icon: '🔋',
    featured: false,
  },
  {
    id: 'pk-woven-pp-sack',
    name: 'Woven PP Sack 50 kg (Printed)',
    sku: 'NG-PK-PP-50',
    factory: 'Tema Sack & Bag Co.',
    category: 'Packaging',
    description:
      'Laminated woven polypropylene sacks for grains, feed, and cement. Ghana-made; ECOWAS trade-friendly for Nigerian importers.',
    specs: {
      Capacity: '50 kg',
      Material: 'Woven PP + lamination',
      Print: '1–2 colour',
      Origin: 'Tema, Ghana',
      Bale: '500 pcs',
    },
    moq: 5000,
    unit: 'pcs',
    unitPrice: 0.28,
    unitPriceNgn: 450,
    priceTiers: [
      { minQty: 5000, price: 0.28 },
      { minQty: 20000, price: 0.24 },
      { minQty: 100000, price: 0.2 },
    ],
    priceTiersNgn: [
      { minQty: 5000, price: 450 },
      { minQty: 20000, price: 385 },
      { minQty: 100000, price: 320 },
    ],
    leadTimeDays: 21,
    icon: '🌾',
    featured: false,
  },
  {
    id: 'ip-palm-oil-press-parts',
    name: 'Palm Oil Screw Press Spare Kit',
    sku: 'NG-IP-POP-KIT',
    factory: 'Onitsha Agro Machinery',
    category: 'Industrial Parts',
    description:
      'Wear parts kit (screw, cage bars, bearings) for small palm oil presses common in the South-East. Stocked for agro-processors and dealers.',
    specs: {
      Contents: 'Screw + cage + bearings',
      Fit: 'Small press 1–3 t/day',
      Origin: 'Onitsha / Anambra',
      Steel: 'Hardened alloy',
      Pack: '1 kit / crate',
    },
    moq: 10,
    unit: 'kits',
    unitPrice: 185.0,
    unitPriceNgn: 296000,
    priceTiers: [
      { minQty: 10, price: 185.0 },
      { minQty: 30, price: 165.0 },
      { minQty: 80, price: 148.0 },
    ],
    priceTiersNgn: [
      { minQty: 10, price: 296000 },
      { minQty: 30, price: 264000 },
      { minQty: 80, price: 236800 },
    ],
    leadTimeDays: 16,
    icon: '🌴',
    featured: true,
  },

];

/** Flat inland haulage estimate (NGN) — Lagos port / warehouse to buyer. */
export const FREIGHT_FLAT_NGN = 125000;

export function priceForQty(product, qty) {
  const tiers = [...(product.priceTiers || [])].sort((a, b) => b.minQty - a.minQty);
  for (const t of tiers) {
    if (qty >= t.minQty) return t.price;
  }
  return product.unitPrice;
}

/** NGN unit price for a quantity (explicit NGN tiers/price, else USD × USD_TO_NGN). */
export function priceForQtyNgn(product, qty) {
  if (product.priceTiersNgn?.length) {
    const tiers = [...product.priceTiersNgn].sort((a, b) => b.minQty - a.minQty);
    for (const t of tiers) {
      if (qty >= t.minQty) return t.price;
    }
    return product.unitPriceNgn ?? tiers[tiers.length - 1].price;
  }
  if (product.unitPriceNgn != null && product.unitPrice) {
    const usd = priceForQty(product, qty);
    return Math.round((usd / product.unitPrice) * product.unitPriceNgn);
  }
  if (product.unitPriceNgn != null) return product.unitPriceNgn;
  return Math.round(priceForQty(product, qty) * USD_TO_NGN);
}
